export const REST_ROOT_URL = `/rest/storefront`;
export const ERROR_URL = `/rest/internal/v1/storefront/clientErrorLog`;
export const STOREFRONT_CHECKOUT_URL = `/order/user-account?projectId=`;
